import React, { useCallback } from 'react';

import { Stack, xcss } from '@atlaskit/primitives';

import { BulkCreateBody } from './BulkCreateBody';
import { BulkCreateHeader } from './BulkCreateHeader';
import { BulkCreateFooter } from './BulkCreateFooter';
import { SidePanelWrapper } from './SidePanelWrapper';
import {
	BULK_ISSUE_CREATE_SOURCE,
	useBulkCreateLoggingEvents,
} from './utils/useBulkCreateLoggingEvents';
import {
	useBulkCreateContext,
	ErrorMessageMap,
	ErrorStates,
	AiStates,
} from './providers/BulkCreateContextProvider';
import { AiCreationError } from './AiCreationError';
import { IssueCreateAiLoading } from './IssueCreateAiLoading';

const contentStyles = xcss({
	width: '100%',
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
	flexWrap: 'nowrap',
});

export const AiBulkDefaultView = ({ onClose }: { onClose: () => void }) => {
	const { logCancelAiPanel } = useBulkCreateLoggingEvents();
	const onPanelClose = useCallback(() => {
		logCancelAiPanel();
		onClose();
	}, [logCancelAiPanel, onClose]);

	const [{ aiState, error }] = useBulkCreateContext();
	const isLoading = aiState === AiStates.LOADING;
	const isError = error !== ErrorStates.EMTPY;
	const isComplete = !isLoading && !isError;

	return (
		<SidePanelWrapper>
			<Stack xcss={contentStyles}>
				<BulkCreateHeader onClose={onPanelClose} />
				{isLoading && <IssueCreateAiLoading />}
				{isError && (
					<AiCreationError
						creationSource={BULK_ISSUE_CREATE_SOURCE}
						errorMessage={ErrorMessageMap[error]}
					/>
				)}
				{isComplete && (
					<>
						<BulkCreateBody />
						<BulkCreateFooter onClose={onPanelClose} />
					</>
				)}
			</Stack>
		</SidePanelWrapper>
	);
};
